import { Api } from '@/services/apiService';

class stateCatalogue {
    static async index() {
        return Api.get('/state-catalogue', { baseURL: '/new-api' });
    }
}

export default stateCatalogue;
